import React, { Component, PropTypes } from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';
import { ReduxRouter } from 'redux-router';
import { connect } from 'react-redux';

import App from 'containers/App/App';
import Dashboard from 'containers/Dashboard/Dashboard';
import Login from 'containers/Authorization/Login/Login';
import SignUp from 'containers/Authorization/SignUp/SignUp';
import ForgotPassword from 'containers/Authorization/ForgotPassword/ForgotPassword';
import NewPassword from 'containers/Authorization/NewPassword/NewPassword';
import Profile from 'containers/Profile/Profile';
import CpdLocker from 'containers/CpdLocker/CpdLocker';
import CpdRecorded from 'containers/CpdLocker/CpdRecorded';
import CpdLive from 'containers/CpdLocker/CpdLive';
import NotFound from 'containers/NotFound/NotFound';
import OnlineWebinar from 'containers/Webinar/OnlineWebinar.jsx';
import ConfirmEmailView from 'components/ConfirmEmail/ConfirmEmail';
import ConfirmEmail from 'containers/ConfirmEmail/ConfirmEmail';
import Webinars from 'containers/Admin/Webinar/Webinars';
import EditWebinar from 'containers/Admin/Webinar/EditWebinar';
import Users from 'containers/Admin/User/Users';
import AboutUs from 'components/Plain/AboutUs';
import PrivacyPolicy from 'components/Plain/PrivacyPolicy';
import CookiePolicy from 'components/Plain/CookiePolicy';
import TermsOfService from 'components/Plain/TermsOfService';
import Landing from 'containers/Landing/Landing';
import StatisticsDashboard from 'containers/Admin/Statistics/Dashboard';
import JoinWebinar from 'containers/JoinWebinar';
import RegisteredUserForWebinar from 'containers/Admin/Webinar/RegisteredUsers.jsx';

import NewWebinar from 'containers/Admin/Webinar/NewWebinar';
import NewUser from 'containers/Admin/User/NewUser';
import EditUser from 'containers/Admin/User/EditUser';

import Sponsors from 'containers/Admin/Sponsor/Sponsors';
import SponsorsDashboard from 'containers/SponsorsDashboard';

import SponsorsRouteInterceptor from 'components/SponsorsRouteInterceptor';
import NewSponsor from 'containers/Admin/Sponsor/NewSponsor';
import EditSponsor from 'containers/Admin/Sponsor/EditSponsor';

import UsersSponsors from 'containers/Admin/UserSponsors/UsersSponsors';
import NewUserSponsor from 'containers/Admin/UserSponsors/NewUserSponsor';
import EditUserSponsor from 'containers/Admin/UserSponsors/EditUserSponsor';

import actions from 'actions';


const {
  loadSponsorsSaga
} = actions;

class AppRouter extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadSponsors();
  }

  sponsorCustomRoutes = () => {
    const { sponsors } = this.props;
    const validSponsors = sponsors.filter(el => !!el.namespace);

    return validSponsors.map(sponsor => {
      return <Route path={`/${sponsor.namespace}`} component={SponsorsDashboard} />
    });
  }

  publicRoutes = () => [
    <Route path="/about_us" component={AboutUs} />,
    <Route path="/privacy_policy" component={PrivacyPolicy} />,
    <Route path="/terms_of_service" component={TermsOfService} />,
    <Route path="/cookie_policy" component={CookiePolicy} />
  ];

  guestRoutes = () => [
    <Route path="/users/sign_in" component={Login} />,
    <Route path="/users/sign_up" component={SignUp} />,
    <Route path="/users/forgot_password" component={ForgotPassword} />,
    <Route path="/update_passwords" component={NewPassword} />,
    <Route path="/" component={Landing} />,
    <Route path="/confirm_email*" component={ConfirmEmail} />,
    <Route path="/join_webinar/:id" component={JoinWebinar} />,
    ...this.publicRoutes()
  ];

  watchUrlRoutes = () => [
    <Route path="/webinars/:id" component={Landing} />,
    ...this.guestRoutes()
  ]

  loggedAsHospDoctorOrConsultant = () => [
    <Route path="/" exact component={Dashboard} />,
    <Route path="/users/profile" component={Profile} />,
    <Route path="/webinars/:id" component={OnlineWebinar} />,
    <Route path="/join_webinar/:id" component={JoinWebinar} />,
    ...this.publicRoutes(),
    ...this.sponsorCustomRoutes(),
    ...(this.props.isLoaded ? [] : [<Route path="*" component={SponsorsRouteInterceptor} />])
  ];

  loggedRoutesForOther = () => [
  <Route path="/cpd" component={CpdLocker}>
      <IndexRoute component={CpdLive} />
      <Route path="recorded" component={CpdRecorded} />
      <Route path="live" component={CpdLive} />
    </Route>,
    <Route path="/" exact component={Dashboard} />,
    <Route path="/users/profile" component={Profile} />,
    <Route path="/webinars/:id" component={OnlineWebinar} />,
    <Route path="/join_webinar/:id" component={JoinWebinar} />,
    ...this.publicRoutes(),
    ...this.sponsorCustomRoutes(),
    ...(this.props.isLoaded ? [] : [<Route path="*" component={SponsorsRouteInterceptor} />])
  ];

  loggedRoutes = () => {
    if (this.props.user.user_type === 'consultant') {
      return this.loggedAsHospDoctorOrConsultant();
    } else if (this.props.user.user_type === 'hospital_doctor') {
      return this.loggedAsHospDoctorOrConsultant();
    }
    return this.loggedRoutesForOther();
  };

  adminRoutes = () => [
    <Route path="/webinars/new" exact component={NewWebinar} />,
    <Route path="/webinars" exact component={Webinars} />,
    <Route path="/webinars/:id" exact component={EditWebinar} />,
    <Route
      path="/webinars/:id/users"
      exact
      component={RegisteredUserForWebinar}
    />,
    <Route path="/users" exact component={Users} />,
    <Route path="/users/new" exact component={NewUser} />,
    <Route path="/users/:id/edit" exact component={EditUser} />,
    <Route path="/sponsors/new" exact component={NewSponsor} />,
    <Route path="/sponsors" exact component={Sponsors} />,
    <Route path="/sponsors/:id" exact component={EditSponsor} />,
    <Route path="/users_sponsors" exact component={UsersSponsors} />,
    <Route path="/users_sponsors/new" exact component={NewUserSponsor} />,
    <Route path="/users_sponsors/:id/edit" exact component={EditUserSponsor} />,
    <Route path="/" exact component={StatisticsDashboard} />
  ];

  unconfirmedRoutes = () => [
    <Route path="/" exact component={ConfirmEmailView} />,
    <Route path="/confirm_email*" component={ConfirmEmail} />,
    <Route path="/join_webinar/:id" component={JoinWebinar} />,
    ...this.publicRoutes()
  ];

  unfilledProfileRoutes = () => [
    <Route path="/users/profile" component={Profile} />,
    <Route path="/join_webinar/:id" component={JoinWebinar} />,
    ...this.publicRoutes()
  ];

  sharedRoutes = () => [];

  routes = () => {
    let routesToRender = [];
    if (this.props.logged) {
      routesToRender = this.loggedRoutes;
      if (this.props.role == 'admin') {
        routesToRender = this.adminRoutes;
      }
      if (!this.props.emailConfirmed && this.props.role != 'admin') {
        routesToRender = this.unconfirmedRoutes;
      }
      if (
        !this.props.user.is_valid &&
        this.props.emailConfirmed &&
        this.props.role != 'admin'
      ) {
        routesToRender = this.unfilledProfileRoutes;
      }
    } else {
      routesToRender = this.watchUrlRoutes;
    }
    return routesToRender();
  };

  rootPath = () => {
    const { logged, user } = this.props;

    if(logged) {
      if(!!user.is_valid || !user.email_confirmed) {
        return '/';
      }
      return '/users/profile';
    }
    return '/users/sign_in';
  }


  render() {
    return (
      <div>
        {this.props.children}
        <ReduxRouter>
          <Route component={App}>
            {this.routes()}
            {this.sharedRoutes()}
            <Redirect from="*" to={`${this.rootPath()}`} />
          </Route>
        </ReduxRouter>
      </div>
    );
  }
}

AppRouter.PropTypes = {
  logged: PropTypes.boolean
};

function mapStateToProps(state) {
  return {
    logged: !!(state.users.user && state.session && state.session.token),
    role: state.users.user.role,
    emailConfirmed: state.users.user.email_confirmed,
    user: state.users.user,
    sponsors: state.sponsors.list.values,
    isLoaded: state.sponsors.list.isLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadSponsors: () => dispatch(loadSponsorsSaga()),
    loadUsersSponsors: () => dispatch(loadSponsorsSaga()),
    dispatch
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/